define([
    "dojo/_base/declare",
    "csi/heading/EnumController",
    "csi/widget/MessageDialog"
], function(declare,EnumController,MessageDialog) {
    
    return declare(EnumController, {
        
        getConfirmButton: function() {
            return MessageDialog.BUTTON_CHANGE;
        },
        
        hasToConfirmAction: function() {
            var priceListRev = this.getNode();
            return priceListRev.Items.length > 0;
        }
        
    });
});